import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Collapse, Alert } from '@mui/material';

import { Styling } from '../../constants';

interface IWarningProps {
  isWarning: boolean;
  message: string;
  fullWidth?: boolean;
}

export const WarningContainer = styled(Alert).attrs({
  severity: 'warning' as const,
})`
  text-transform: uppercase;
  justify-content: center;
  position: relative;
  top: ${Styling.DEFAULT_SPACING}px;
  margin-bottom: ${Styling.DEFAULT_SPACING}px;
`;

const Warning: React.FC<IWarningProps> = (props: IWarningProps) => {
  const [isWarning, setWarning] = useState(props.isWarning);
  useEffect(() => setWarning(props.isWarning), [props.isWarning]);

  const { message, fullWidth } = props;

  return (
    <Collapse
      in={isWarning}
      style={{ width: fullWidth && isWarning ? '100%' : null }}
    >
      <WarningContainer
        style={{ display: isWarning ? 'flex' : 'none' }}
      >
        {message}
      </WarningContainer>
    </Collapse>
  );
};

export default Warning;
